var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"69fa158f1f0103054ed47c6f9220f99ca5b08684"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"69fa158f1f0103054ed47c6f9220f99ca5b08684"};
      